import { render, staticRenderFns } from "./DeleteCaregiverDialog.vue?vue&type=template&id=658f7f70&"
import script from "./DeleteCaregiverDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCaregiverDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports